export var isAnyLoanFinished = function (data) {
    if (!data)
        return false;
    return data.loans.some(function (item) { return item.status === 'OPEN' || item.status === 'CLOSED' || item.status === 'TERMINATED'; });
};
